"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaMinMaxWidth = exports.mediaMinWidth = exports.mediaMaxWidth = exports.BREAKPOINTS = void 0;
exports.BREAKPOINTS = {
    xs: 0,
    // For 400% Zoom, the "small" layout size applies for viewports/breakpoints for screen width of 320px to 679px.
    sm: 320,
    // For 200% Zoom, the "medium" layout size applies for viewports/breakpoints for screen width of 680px to 1023px.
    md: 680,
    lg: 1024,
    xl: 1224,
    xxl: 1600,
};
var mediaMaxWidth = function (key) { return function (style) {
    return "@media (max-width: ".concat(exports.BREAKPOINTS[key], "px) { ").concat(style, " }");
}; };
exports.mediaMaxWidth = mediaMaxWidth;
var mediaMinWidth = function (key) { return function (style) {
    return "@media (min-width: ".concat(exports.BREAKPOINTS[key], "px) { ").concat(style, " }");
}; };
exports.mediaMinWidth = mediaMinWidth;
var mediaMinMaxWidth = function (min, max) {
    return function (style) {
        return "@media only screen and (min-width: ".concat(exports.BREAKPOINTS[min], "px) and (max-width: ").concat(exports.BREAKPOINTS[max], "px) { ").concat(style, " }");
    };
};
exports.mediaMinMaxWidth = mediaMinMaxWidth;
